import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, VERSION, ViewChild, forwardRef, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService, NgxSpinnerModule  } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { DataService } from '../../services/data/data.service';
import { ClaimantService } from '../../services/claimant/claimant.service';
import { Claimant } from '../../models/claimant';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { BsDatepickerConfig, BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { MustMatch } from '../../helpers/must-match.validator';
import { DatePipe } from '@angular/common';
import { Authenticate } from '../../models/authenticate';


@Component({
  selector: 'app-file',
  templateUrl: './file.html',
  styleUrls: ['./file.css'],
  imports: [DatePipe, ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule, MatStepperModule, BsDatepickerModule],
  providers: [provideNgxMask()], // Provide at the component level
})
export class FileForm implements OnInit {
  @ViewChild('listofFiles') tableRef: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;

  authenticatedUser!: Authenticate;
  submitted = false;
  clicked = false;
  clickedOnce = false;
  changed = false;
  allStates: any = [];
  allCountries: any = [];
  claimantsInformation: FormGroup;
  submittedClaim: Claimant;
  response: string | undefined;
  dateLoaded: Date;
  claimStartTime: string;
  claimEndTime: string;
  cdList: any = [];
  showDivProvince: boolean = false;
  showDivCityStateZip: boolean = true;
  showDivPurchaseUploadDocs: boolean = false;
  showDivDisagreePurchaseMessage: boolean = false;
  showSubmittalErrorWarning: boolean = false;
  showQuestionTwo: boolean = false;
  showQuestionThree: boolean = false;
  selectedCountry: any;
  supportingDocuments: any = [];
  today: Date = new Date();


  validation_ClaimDetailsErrorMessage = {
    purchaseYear: [
      { type: 'required', message: 'This Field is required' },
    ],
    defendant: [
      { type: 'required', message: 'This Field is required' },
    ],
    purchaseAmount: [
      { type: 'required', message: 'This field is required' },
      { type: "maxlength", message: "Field cannot be more than 15 digits" },
      { type: "pattern", message: "Only use numbers with optional period (.) and up to 4 digits past decimal." }
    ],
  };
  constructor(
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private storage: LocalStorageService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private dataService: DataService,

    private claimantService: ClaimantService) { }


  ngOnInit() {
    this.dateLoaded = new Date();
    this.dateLoaded = new Date();
    this.claimStartTime = this.dateLoaded.toLocaleTimeString();
    this.loadAllStates();
    this.loadAllCountries();
    this.dataService.getData();
    this.authenticatedUser = this.storage.retrieve('authenticatedUser');

    this.claimantsInformation = this.fb.group({
      chargedUnreimbursedSurcharge: ['', Validators.compose([Validators.required])],
      estimatedTimesPaid: [''],
      chargedUsingDebitCard: [''],
      name1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      street1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      street2: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      city: ['', Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      state: ['', Validators.compose([Validators.required])],
      zip: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")])],
      primaryPhoneType: ['', Validators.compose([Validators.required])],
      primaryPhone: ['', Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],
      emailAddress: ['', Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("^[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")])],
      emailAddressVerify: ['', Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")])],
      signature: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      dateSigned: [this.today],
      uniqueId: ["", Validators.compose([Validators.maxLength(8), Validators.minLength(8), Validators.pattern("^[a-zA-Z0-9]+$")])],
      pin: ["", Validators.compose([Validators.maxLength(6), Validators.minLength(6), Validators.pattern("^[a-zA-Z0-9]+$")])],
      googleRecaptchaToken: ['', Validators.compose([Validators.required])],
    }, {
      validator: MustMatch('emailAddress', 'emailAddressVerify')
    });
    this.claimantsInformation.get('chargedUnreimbursedSurcharge')?.valueChanges.subscribe(value => {
      const statusDateControl = this.claimantsInformation.get('chargedUsingDebitCard');
      if (value === 'Yes') {
        statusDateControl?.enable({ emitEvent: false });
        statusDateControl?.setValidators([Validators.required]);
      } else if (value === 'No') {
        statusDateControl?.reset(null, { emitEvent: false });
        statusDateControl?.clearValidators();
        statusDateControl?.disable({ emitEvent: false });
      } else {
        statusDateControl?.reset(null, { emitEvent: false });
        statusDateControl?.clearValidators();
        statusDateControl?.enable({ emitEvent: false });
      }
      statusDateControl?.updateValueAndValidity();
    });
    this.claimantsInformation.get('chargedUsingDebitCard')?.valueChanges.subscribe(value => {
      const statusDateControl = this.claimantsInformation.get('estimatedTimesPaid');
      if (value === 'Yes') {
        statusDateControl?.enable({ emitEvent: false });
        statusDateControl?.setValidators([Validators.required]);
      } else if (value === 'No') {
        statusDateControl?.reset(null, { emitEvent: false });
        statusDateControl?.clearValidators();
        statusDateControl?.disable({ emitEvent: false });
      } else {
        statusDateControl?.reset(null, { emitEvent: false });
        statusDateControl?.clearValidators();
        statusDateControl?.enable({ emitEvent: false });
      }
      statusDateControl?.updateValueAndValidity();
    });
  }

  loadAllStates() {
    this.httpClient.get("assets/States.json").subscribe(data => {
      /* console.log(data);*/
      this.allStates = data;
    })
  }

  loadAllCountries() {
    this.httpClient.get("assets/Countries.json").subscribe(data => {
      console.log(data);
      this.allCountries = data;
    })
  }

  resolved(captchaResponse: string) {
    this.response = captchaResponse;
  }

  get f() { return this.claimantsInformation.controls; }

  getQuestionOneValue($event) {
    this.changed = true;
    // if you need the event source and value it can be accessed.
    if ($event.target.value === 'Yes') {
      this.showQuestionTwo = true;

      this.claimantsInformation.get('chargedUsingDebitCard').setValidators(Validators.compose([Validators.required]));
      this.claimantsInformation.get('chargedUsingDebitCard').updateValueAndValidity();
    }

    if ($event.target.value === 'No') {
      /* */
      this.showQuestionTwo = false;
      this.claimantsInformation.get('chargedUsingDebitCard').reset();
      this.claimantsInformation.get('chargedUsingDebitCard').clearValidators();
      this.claimantsInformation.get('chargedUsingDebitCard').updateValueAndValidity();
    }
  }

  getQuestionTwoValue($event) {
    this.changed = true;
    // if you need the event source and value it can be accessed.
    if ($event.target.value === 'Yes') {
      this.showQuestionThree = true;

      this.claimantsInformation.get('estimatedTimesPaid').setValidators(Validators.compose([Validators.required, Validators.maxLength(4), Validators.minLength(1), Validators.pattern("^[0-9]+$")]));
      this.claimantsInformation.get('estimatedTimesPaid').updateValueAndValidity();

    }

    if ($event.target.value === 'No') {
      /* */
      this.showQuestionThree = false;

      this.claimantsInformation.get('estimatedTimesPaid').reset();
      this.claimantsInformation.get('estimatedTimesPaid').clearValidators();
      this.claimantsInformation.get('estimatedTimesPaid').updateValueAndValidity();
    }
  }

  getPhoneType2Value() {
    this.changed = true;
    const secondaryPhoneType = this.claimantsInformation.get('secondaryPhoneType')?.value;

    if (secondaryPhoneType !== '') {
      this.claimantsInformation.get('secondaryPhone').setValidators(Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")]));
    } else {
      this.claimantsInformation.get('secondaryPhone').clearValidators();
    }
    this.claimantsInformation.get('secondaryPhone').updateValueAndValidity();
  }

  //getRadioAgreeanceValue($event) {
  //  // if you need the event source and value it can be accessed.
  //  console.log($event.target.value);
  //  if ($event.target.value == 'Disagree') {
  //    this.showDivPurchaseUploadDocs = true;

  //  }
  //  if ($event.target.value == 'Agree') {
  //    this.showDivPurchaseUploadDocs = false;
  //    this.resetFormArray();
  //  }
  //}


  // Clear ClaimDetails Form Array Controls
  resetFormArray() {
    this.claimDetails().clear();
  }

  // Remove the second element and so on
  removeAllExceptFirst(formArray: FormArray): void {
    while (formArray.length > 1) {
      formArray.removeAt(0);
    }
  }

  removeTable() {
    if (this.tableRef) {
      this.tableRef.nativeElement.remove();
    }
  }

  // Declare FormArray Function
  claimDetails(): FormArray {
    return this.claimantsInformation.get('claimDetails') as FormArray
  }

  // Create new Form Array
  newClaimDetail(): FormGroup {
    return this.fb.group({
      purchaseYear: ['', Validators.compose([Validators.required])],
      defendant: ['', Validators.compose([Validators.required])],
      purchaseAmount: ['', Validators.compose([Validators.required, Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
    });
  }

  // Create a New Array Function
  claimDetailARR(index) {
    this.cdList = this.claimantsInformation.get('claimDetails') as FormArray;
    const formGroup = this.cdList.controls[index] as FormGroup;
    return formGroup;
  }

  addData() {
    (<FormArray>this.claimantsInformation.get('claimDetails')).push(this.newClaimDetail());
    this.showDivDisagreePurchaseMessage = false;
  }

  removeData(i: number) {
    this.claimDetails().removeAt(i)
  }

  getFileDetails(e) {
    console.log(this.supportingDocuments);
    for (var i = 0; i < e.target.files.length; i++) {
      this.supportingDocuments.push(e.target.files[i]);
      //console.log(e.target.files[i]);
      //if (this.supportingDocuments.length >= 1) {
      //  this.showDivUploadDocumentMessage = false;
      //}
    }
  }

  removeRow(i: number) {
    this.supportingDocuments.splice(i, 1);
    this.fileInput.nativeElement.value = null;
  }

  onSubmit() {
    this.submitted = true;
    this.dateLoaded = new Date();
    this.claimEndTime = this.dateLoaded.toLocaleTimeString();
    // stop here if form is invalid
    if (this.claimantsInformation.invalid) {
      return;
    }

    this.clicked = true;
    const claimant = this.claimantsInformation.value;
    
    if (this.authenticatedUser !== null) {
      claimant.uniqueId = this.authenticatedUser.uniqueId;
      claimant.pin = this.authenticatedUser.pin;
      claimant.wasClaimantNoticed = true;
    }
    if (this.authenticatedUser === null) {
      claimant.wasClaimantNoticed = false;
    }


    claimant.claimStartTime = this.claimStartTime;
    claimant.claimEndTime = this.claimEndTime;

    this.spinner.show();

    /*console.log(claimant);*/
    this.CreateClaimant(claimant);
  }

  CreateClaimant(claimant: Claimant) {
    this.claimantService.createClaimant(claimant).subscribe(res => {
      this.submittedClaim = res;
      if (this.submittedClaim.claimNumber === null || this.submittedClaim.googleRecaptchaToken === null || this.submittedClaim.googleRecaptchaSuccess === 'false') {
        this.spinner.hide();
        return;
      }
      this.storage.store('claimant', this.submittedClaim);


      //localStorage.removeItem('authenticatedUser');
      //4
      //localStorage.removeItem('utmTags');


      this.storage.clear('authenticatedUser');
      this.storage.clear('utmTags');

      this.submitted = false;
      this.claimantsInformation.reset();

      this.spinner.hide();
      this.router.navigate(['/complete']);

      //this.storage.store('claimant', this.submittedClaim);
      //this.submitted = false;
      //this.storage.clear('utmTags'); // Clear UTM tags after submission
      //this.authenticatedUser = null; // Clear authenticated user after submission 
      //this.claimantsInformation.reset();
      //this.spinner.hide();
      //this.router.navigate(['/complete']);

    });
  }
}
